<template>
    <div class="part6-wrap">
      <div class="title-wrap">
        <v-title class="title" :text="'关于我们'"></v-title>
      </div>
      <div class="main">
        <div class="con">
          <div class="text">
            <h3>南京跨链科技有限公司是一家专注于开发研究数字货币创新模式与区块链技术的技术型公司，是国内较早的区块链平台提供商。
            </h3>
            <p>团队大部分成员都来自南大、浙大等知名学府，团队自主研发的区块链技术平台融合了现有区块链系统的优点，
              如DPOS共识、智能合约、链上多资产、链上交易所、跨链资产转移等，在全球范围内处于领先水平。
              我们对于各类数字钱包的代码极为熟悉，因此对于钱包资产的管理也有很好的技术方案。多年区块链底层技术的沉淀与积累，丰富的项目经验，
              我们能为客户提供稳定，高效的服务以及解决问题的最佳方案。</p>
            <p>跨链为每位签约客户提供完全符合其业务经营模式的软件支持服务，提供成熟、安全的区块链底层技术支持，并以客户口碑作为企业持续经营的基础，
              快速发展成为业内标杆级数字货币相关软件及解决方案提供商。</p>
          </div>
          <div class="img" :class="{'img-none':!flag}">
          </div>
        </div>
      </div>
      <v-footer class="foot"></v-footer>
    </div>
</template>

<script>
    import VTitle from "../plug/VTitle";
    import VFooter from "../plug/VFooter";

    export default {
      components: {
        VFooter,
        VTitle},
      name: "part6",
      props: ['flag']
    }
</script>

<style lang="less" scoped>
.part6-wrap {
  position: relative;
  height: 100%;
  .title-wrap {
    position: relative;
    height: 20%;
    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -100%);
    }
  }
  .main {
    width: 100%;
    height: 50%;
    .con {
      width: 80%;
      height: 100%;
      min-width: 1180px;
      margin: auto;
      display: flex;
      /*justify-content: space-between;*/
      .text {
        flex: 1;
        height: 100%;
        padding-right: 20px;
        font-size: 1.55rem;
        p {
          color: #999999;
          margin-top: 26px;
        }
      }
      .img {
        flex: 1;
        height: 100%;
        background: url("../../assets/img/part6-p1.jpg");
        background-size: 100% 100%;
      }
      .img-none {
        background: none;
      }
    }
  }
  .foot {
    height: 10%;
    position: absolute;
    bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/part6/Part6.vue